var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3524_15683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.0002C18.6274 24.0002 24 18.6277 24 12.0002C24 5.37283 18.6274 0.000244141 12 0.000244141C5.37258 0.000244141 0 5.37283 0 12.0002C0 18.6277 5.37258 24.0002 12 24.0002Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7832 16.1738L7.82669 23.2536C9.12662 23.736 10.5327 23.9999 12.0006 23.9999C17.1601 23.9999 21.5587 20.7434 23.2541 16.1738H6.7832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7832 7.82611L7.82669 0.746297C9.12662 0.263906 10.5327 0 12.0006 0C17.1601 0 21.5587 3.2565 23.2541 7.82611H6.7832Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9999C0 17.1595 3.25655 21.558 7.82611 23.2536V0.746338C3.25655 2.44185 0 6.84037 0 11.9999Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3524_15683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAed);
export default __webpack_public_path__ + "static/media/AED.33ea35b20214c4ee6c096a2ece0f5762.svg";
export { ForwardRef as ReactComponent };